import { render, staticRenderFns } from "./BackofficeHonorarioMedico.vue?vue&type=template&id=b3b42ee4"
import script from "./BackofficeHonorarioMedico.vue?vue&type=script&lang=ts"
export * from "./BackofficeHonorarioMedico.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports